import { PropsWithChildren, ReactNode } from 'react'
import { cn } from '~/lib/utils'
import cs from './metadata_sidebar.scss'

/**
 * A sidebar (or section of a sidebar) that displays generic key-value metadata.
 *
 * @example
 *   <MetadataSidebar>
 *     <MetadataItem label="Created by">
 *       Jon
 *     </MetadataItem>
 *
 *     <MetadataItem label={
 *       <span className={cs.status}>Status</span>
 *     }>
 *       Unread
 *     </MetadataItem>
 *   </MetadataSidebar>
 */
export default function MetadataSidebar({
  children,
  className,
  childClassName,
}: PropsWithChildren<unknown> & { className?: string; childClassName?: string }) {
  return (
    <aside className={cn(className)}>
      <dl className={cn(cs.metadata, childClassName)}>{children}</dl>
    </aside>
  )
}

export function MetadataItem({
  label,
  children,
}: PropsWithChildren<{ label: ReactNode }>) {
  return (
    <>
      <dt>{label}</dt>
      <dd>{children}</dd>
    </>
  )
}
